import React from 'react'
import { Dimensions, Platform } from 'react-native'
import { bigTextSize, CHECKOUT_FOOTER_HEIGHT } from '../../../constants/GlobalStyle'
import { View } from '../../../components/Themed'
import { MaterialCommunityIcons } from '@expo/vector-icons'
import Colors from '../../../constants/Colors'
import { Box, Button, Stack, Text, useBreakpoints } from '../../../components/DesignSystem'
import CopyrightFooter from '../../../components/Footers/CopyrightFooter'
import TapForTestMode from '../../../components/OrderCart/TapForTestMode'

export default function NoItemsInCart({ navigation }) {
	const { isMobile } = useBreakpoints()
	return (
		<>
			<Box
				style={{
					position: 'absolute',
					top: Dimensions.get('window').height * 0.25,
					bottom: 0,
					left: 0,
					right: 0,
					paddingHorizontal: '15%',
					justifyContent: 'center',
					zIndex: 1,
				}}
			>
				<View
					style={{
						marginTop: -Dimensions.get('window').height * 0.25,
						alignItems: 'center',
						alignSelf: 'center',
					}}
				>
					<MaterialCommunityIcons
						name="shopping-outline"
						size={bigTextSize * 1.5}
						color={Colors.greyscale[6]}
					/>
					<Text
						level={isMobile ? 'body' : 'subheadline'}
						weight="medium"
						tone="secondary"
						style={{ textAlign: 'center', marginTop: 15, maxWidth: 450 }}
					>
						You have not added anything to your order.
					</Text>
					<TapForTestMode />
				</View>

				<Button
					onPress={() => navigation.navigate('HomeStack', { screen: 'RestaurantSelect' })}
					variant="primary"
					size={isMobile ? 'small' : 'medium'}
					backgroundColor="black"
					icon={<MaterialCommunityIcons name="cart-outline" size={24} color="white" />}
					style={{
						width: '70%',
						maxWidth: 400,
						marginTop: isMobile ? 48 : 64,
						alignSelf: 'center',
					}}
				>
					ADD ITEMS
				</Button>
			</Box>

			{Platform.OS === 'web' && <CopyrightFooter />}
		</>
	)
}
